import { render, staticRenderFns } from "./PrimePdfUploader.vue?vue&type=template&id=06e7e823&scoped=true"
import script from "./PrimePdfUploader.vue?vue&type=script&lang=js"
export * from "./PrimePdfUploader.vue?vue&type=script&lang=js"
import style0 from "./PrimePdfUploader.vue?vue&type=style&index=0&id=06e7e823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7e823",
  null
  
)

export default component.exports